// import React, { useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import carImages from '../Data/carImages';
// import { FaCogs, FaUsers } from 'react-icons/fa';
// import './PopularCars.css';

// const RecomandedCars = ({ data, setAllCars }) => {
//     const { id, name, img, manufacturer, type, capacity, perDay, vehicleType, isBooked } = data;
//     const navigate = useNavigate();
//     const boxRef = useRef(null);

//     // Function to book the car
//     const bookCar = async (carId) => {
//         try {
//             await axios.put(`https://carrentalbackend.dockyardsoftware.com/api/CarDetail/update-booking-status/${carId}`, { isBooked: true });
//             setAllCars(prevCars => prevCars.map(car => car.id === carId ? { ...car, isBooked: true } : car));
//         } catch (error) {
//             console.error("There was an error updating the booking status!", error);
//         }
//     };

//     const handleRentNowClick = () => {
//         console.log('Selected Car Details:', data);
//         bookCar(id);
//         navigate('/detail-page', { state: { selectedCar: data } });
//     };

//     const formattedPerDay = `Rs. ${perDay}.00/day`;

//     const carImage = carImages.find(car => car.id === id)?.image1;

//     useEffect(() => {
//         const observer = new IntersectionObserver((entries) => {
//             entries.forEach(entry => {
//                 if (entry.isIntersecting) {
//                     entry.target.classList.add('animate-on-scroll');
//                     observer.unobserve(entry.target);
//                 }
//             });
//         }, { threshold: 0.1 });

//         if (boxRef.current) {
//             observer.observe(boxRef.current);
//         }

//         return () => {
//             if (boxRef.current) {
//                 observer.unobserve(boxRef.current);
//             }
//         };
//     }, []);

//     return (
//         <div className={`vehicle-box ${isBooked ? 'booked' : ''}`} ref={boxRef}>
//             <div className="vehicle-info">
//                 <h3>{name}</h3>
//                 <p>{typeof vehicleType === 'string' ? vehicleType : vehicleType.join(', ')}</p>
//                 <p>Status: {isBooked ? 'Booked' : 'Available'}</p>
//             </div>

//             <img src={`https://carrentalbackend.dockyardsoftware.com/api/CarDetail/GetImage/${id}`} alt={name} className="w-full h-40 object-contain my-3 mt-10" />
           
//             <div className="vehicle-details ">
//                 <p className="transmission-type mt-10"><FaCogs /> {type}</p>
//                 <p className="capacity mt-10"><FaUsers /> {capacity} people</p>
//             </div>
//             <div className="rent-button-container">
//                 <p dangerouslySetInnerHTML={{ __html: `<span class="price">${formattedPerDay}</span>` }} />
//                 <button className="rent-button" onClick={handleRentNowClick} disabled={isBooked}>
//                     Rent Now
//                 </button>
//             </div>
//         </div>
//     );
// };

// export default RecomandedCars;





import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaCar, FaGasPump, FaUsers, FaStar, FaRegStar, FaHeart, FaRegHeart } from 'react-icons/fa';
import { FiClock, FiZap } from 'react-icons/fi';

const RecomandedCars = ({ data }) => {
  const { id, name, manufacturer, type, capacity, perDay, vehicleType, isBooked, rating,gasoline } = data;
  const [isFavorite, setIsFavorite] = useState(false);
  const navigate = useNavigate();

  const handleRentNowClick = () => {
    if (!isBooked) {
      navigate('/detail-page', { state: { selectedCar: data } });
    }
  };

  const toggleFavorite = (e) => {
    e.stopPropagation();
    setIsFavorite(!isFavorite);
  };

  const renderRatingStars = () => {
    return Array(5).fill(0).map((_, i) => (
      i < Math.floor(rating || 4.5) ? (
        <FaStar key={i} className="text-yellow-400 text-xs" />
      ) : (
        <FaRegStar key={i} className="text-gray-300 text-xs" />
      )
    ));
  };

  return (
    <motion.div 
      className="relative bg-white rounded-2xl shadow-sm overflow-hidden border border-blue-50 hover:shadow-md transition-all duration-300"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ y: -3 }}
      transition={{ duration: 0.2 }}
    >
      {/* Premium Ribbon */}
      <div className="absolute top-0 left-0 w-24 h-6 overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full bg-blue-600 transform -skew-x-30 flex items-center justify-center">
          <FiZap className="text-white text-xs mr-1" />
          <span className="text-xs font-bold text-white">RECOMMENDED</span>
        </div>
      </div>

      {/* Image Section */}
      <div className="relative h-40 bg-gradient-to-br from-blue-50 to-blue-100">
        <img 
          src={`https://carrentalbackend.dockyardsoftware.com/api/CarDetail/GetImage/${id}`} 
          alt={name} 
          className="w-full h-full object-contain object-center p-4 transition-transform duration-500 hover:scale-110"
          loading="lazy"
        />
        
        {/* Top Right Badges */}
        <div className="absolute top-3 right-3 flex flex-col items-end space-y-2">
          <button 
            onClick={toggleFavorite}
            className="p-1.5 bg-white rounded-full shadow-sm hover:bg-gray-50 transition-colors"
            aria-label={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
          >
            {isFavorite ? (
              <FaHeart className="text-red-500 text-sm" />
            ) : (
              <FaRegHeart className="text-gray-400 text-sm" />
            )}
          </button>
          
          <span className={`px-2 py-1 text-xs font-medium rounded-full ${
            isBooked ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'
          }`}>
            {isBooked ? 'Booked' : 'Available'}
          </span>
        </div>
      </div>

      {/* Content Section */}
      <div className="p-4">
        <div className="flex justify-between items-start mb-3">
          <div>
            <h3 className="text-base font-semibold text-gray-900 line-clamp-1">{name}</h3>
            <p className="text-xs text-blue-600 font-medium">{manufacturer?.name || 'Premium Brand'}</p>
          </div>
          <div className="flex items-center space-x-0.5 bg-blue-50 px-2 py-1 rounded-full">
            {renderRatingStars()}
            <span className="text-xs font-bold text-blue-700 ml-0.5">{rating || 4.0}</span>
          </div>
        </div>

        {/* Specs Grid */}
        <div className="grid grid-cols-3 gap-2 mb-4">
          <div className="flex flex-col items-center p-1.5 bg-blue-50 rounded-lg">
            <FaCar className="text-blue-600 mb-1 text-xs" />
            <span className="text-2xs font-medium text-gray-700">{vehicleType}</span>
          </div>
          <div className="flex flex-col items-center p-1.5 bg-blue-50 rounded-lg">
            <FaGasPump className="text-blue-600 mb-1 text-xs" />
            <span className="text-2xs font-medium text-gray-700">{gasoline}</span>
          </div>
          <div className="flex flex-col items-center p-1.5 bg-blue-50 rounded-lg">
            <FaUsers className="text-blue-600 mb-1 text-xs" />
            <span className="text-2xs font-medium text-gray-700">{capacity}</span>
          </div>
        </div>

        {/* Price & CTA */}
        <div className="flex justify-between items-center pt-3 border-t border-blue-100">
          <div>
            <p className="text-xs text-blue-500 mb-0.5">Exclusive deal</p>
            <div className="flex items-baseline">
              <p className="text-base font-bold text-blue-700">Rs. {perDay}</p>
              <p className="text-xs text-gray-500 ml-1">/day</p>
            </div>
          </div>
          <button 
            onClick={handleRentNowClick}
            disabled={isBooked}
            className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${
              isBooked 
                ? 'bg-gray-100 text-gray-400 cursor-not-allowed' 
                : 'bg-blue-600 text-white hover:bg-blue-700 active:scale-95'
            }`}
          >
            {isBooked ? (
              <span className="flex items-center text-xs">
                <FiClock className="mr-1" /> Booked
              </span>
            ) : 'Reserve Now'}
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default RecomandedCars;